// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","EPGButtonWrapper":"RFxMQ1","isSticky":"wGZUjB","topPadded":"_2kkTa3","EPGButton":"_3T97Tl","icon":"_1wYcah","fadeInFrames":"_20EjQ_"};